import React from 'react';
import { Link } from 'react-router-dom';
import windowsImg from '../../assets/city-hardware-windows.png';
import './WindowRepairCTA.css';

function WindowRepairCTA() {
  return (
    <section className="window-cta">
      <div className="container window-cta__inner">
        <div className="window-cta__content">
          <div className="window-cta__eyebrow">Window Repair Specialists</div>
          <h2 className="window-cta__heading">
            Don't Replace<br/>What Can Be Repaired.
          </h2>
          <p className="window-cta__sub">
            Clear views. Secure frames. Fast fixes for broken or aging windows.
            City Hardware is Detroit's go-to for practical window repair done right.
          </p>
          <div className="window-cta__actions">
            <Link to="/window-repair" className="window-cta__btn-primary">
              Get a Window Repair Quote
            </Link>
            <a href="tel:+13135828860" className="window-cta__btn-secondary">
              Talk to Our Repair Team
            </a>
          </div>
        </div>

        <div className="window-cta__visual">
          <img
            src={windowsImg}
            alt="Freshly repaired window frames ready for installation"
            className="window-cta__photo"
          />
          <div className="window-cta__photo-badge">
            Repair · Replace · Restore
          </div>
        </div>
      </div>
    </section>
  );
}

export default WindowRepairCTA;
